export const WELLNESS_ROOT_PATH = '/wellness'

export function stripWellnessPrefix(pathname = '') {
  const normalizedPath = pathname || '/'

  if (normalizedPath === WELLNESS_ROOT_PATH) {
    return '/'
  }

  if (normalizedPath.startsWith(`${WELLNESS_ROOT_PATH}/`)) {
    return normalizedPath.slice(WELLNESS_ROOT_PATH.length) || '/'
  }

  return normalizedPath
}

export function buildWellnessPath(path = '') {
  const pathWithLeadingSlash = path.startsWith('/') ? path : `/${path}`

  if (pathWithLeadingSlash === '/') {
    return WELLNESS_ROOT_PATH
  }

  if (
    pathWithLeadingSlash === WELLNESS_ROOT_PATH ||
    pathWithLeadingSlash.startsWith(`${WELLNESS_ROOT_PATH}/`)
  ) {
    return pathWithLeadingSlash
  }

  return `${WELLNESS_ROOT_PATH}${pathWithLeadingSlash}`
}

export function buildWellnessTilePath(tileId, policyId) {
  const tilePath = tileId ? `/tile/${tileId}` : '/tile'
  return buildWellnessPath(`${tilePath}${policyId ? `/${policyId}` : ''}`)
}

export function buildWellnessOnboardingPath(search = '') {
  return `${WELLNESS_ROOT_PATH}/onboarding${search}`
}

export function isWellnessTilePath(pathname = '') {
  const pathWithoutWellnessPrefix = stripWellnessPrefix(pathname)
  return (
    pathWithoutWellnessPrefix === '/tile' ||
    pathWithoutWellnessPrefix.startsWith('/tile/')
  )
}

export function startsWithWellnessAwarePath(pathname = '', prefixes = []) {
  const pathWithoutWellnessPrefix = stripWellnessPrefix(pathname)

  return prefixes.some((prefix) => {
    return (
      pathWithoutWellnessPrefix === prefix ||
      pathWithoutWellnessPrefix.startsWith(`${prefix}/`)
    )
  })
}
